import React from 'react';

const TAB_KEY_CODE = 9;

const RuleCard = ({ isActive, onClick, children }) => {
  const handleClick = () => {
    if (isActive) {
      return;
    }
    onClick();
  };

  const onKeyDown = (e) => {
    if (e.charCode === TAB_KEY_CODE && !isActive) {
      onClick();
    }
  };

  return (
    <div
      role='button'
      className={isActive ? 'rule-card active-rule' : 'rule-card'}
      onClick={handleClick}
      tabIndex={-1}
      onKeyDown={onKeyDown}
    >
      {children}
    </div>
  );
};

export default RuleCard;
